﻿
const slugElements = document.querySelectorAll('[data-slug]');
const url = '/api/utils/getSlug';

slugElements.forEach((slugElement) => {
  let option = JSON.parse(slugElement.dataset.slug);
  let source = document.querySelector(option.sourceSelector);

  let inDebounce;
  source.addEventListener('keyup', (event) => {
	clearTimeout(inDebounce);
	let isReadonly = slugElement.hasAttribute('readonly');
	if (isReadonly)
	  return;

	if (source.value) {
	  inDebounce = setTimeout(function () {

		fetch(`${url}?input=${source.value}`)
		  .then(response => response.text())
		  .then(data => {
			slugElement.value = data
		  });
	  }, 300);
	} else {
	  slugElement.value = '';
	}
  });
});